module.exports = __webpack_public_path__ + "static/img/planimg.251df34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planimg.jpg
// module id = QIjt
// module chunks = 1